<template>
  <div
    style="
      padding-bottom: 20px;
      color: #000000;
      display: flex;
      justify-content: center;
      flex-direction: column;
    "
  >
    <table
      v-show="status == 'print'"
      id="printTable"
      style="
        width: 100%;
        border-collapse: collapse;
        font-size: 10px !important;
        border: 2px solid black;
      "
    >
      <thead>
        <tr>
          <td colspan="6" align="center" style="font-size: 16px; font-weight: bold">
            <div
              v-if="
                userInfoProp &&
                userInfoProp.init &&
                userInfoProp.init.logo &&
                userInfoProp.init.logo.link
              "
              style="display: flex; justify-content: center"
            >
              <img
                :src="userInfoProp.init.logo.link || require('@/assets/abriron.png')"
                width="45"
                height="45"
              />
            </div>
            <div style="display: flex; justify-content: center">
              <span>{{ $store.state.abrName }}</span>
            </div>
            <div
              v-if="branchProp && branchProp.name"
              style="display: flex; justify-content: center"
            >
              <span style="font-size: 10px">{{
                $t("branch") + ": " + branchProp.name
              }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="4" style="border-left: #ffffff; font-size: 10px">
            <div style="display: grid">
              <!--              <div>-->
              <!--                {{ $t('id') }} : {{ id }}-->
              <!--              </div>-->
              <div>{{ $t("number") }} : {{ number }}</div>
            </div>
          </td>
          <td colspan="2" style="border-right: #ffffff">
            <div style="display: grid; float: left">
              <div style="text-align: left">
                {{ time }}
              </div>
              <div style="text-align: left">
                {{ date }}
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td style="width: 100%" colspan="6">
            <div style="font-size: 10px; padding-right: 5px">
              <div>{{ $t("detailsName") }} : {{ account ? account.name : "" }}</div>
              <div>{{ $t("mobile") }} : {{ account ? account.mobile : "" }}</div>
              <div>{{ $t("address") }} :{{ account ? account.address : "" }}</div>
            </div>
          </td>
        </tr>
        <tr class="table-header-print">
          <td align="center">#</td>
          <td align="center">{{ $t("product") }}/ {{ $t("service") }}</td>
          <td align="center">تعداد / وزن</td>
          <td align="center">
            {{ $t("fee") }}
          </td>
          <td align="center">{{ $t("discount") }}/ {{ $t("tax") }}</td>
          <td align="center">
            {{ $t("sum") }}
          </td>
        </tr>
      </thead>
      <tbody v-if="items">
        <tr v-for="(item, i) in items" :key="i">
          <td>{{ i + 1 }}</td>
          <td style="color: #000000">
            {{ item.product ? item.product.name : "" }}
          </td>
          <td align="center" v-if="item && item.product">
            {{ item.count ? item.count : item.product.count }}
          </td>
          <td align="center" v-if="item && item.product">
            {{
              item.product.totalPerProduct
                ? $numberFormat(Number(item.product.price.replace(/,/g, "")))
                : $numberFormat(item.fee)
            }}
          </td>
          <td align="center" v-if="item && item.product">
            <div class="d-flex flex-column gap-1">
              <div class="d-flex align-center gap-1">
                <span>ت:</span>
                <span>
                  {{ item.discount ? $numberFormat(item.discount) : 0 }}
                  {{ item.discount ? "(" + item.discountPercent + "%)" : "" }}
                </span>
              </div>
              <div class="d-flex align-center gap-1">
                <span>م:</span>
                <span>
                  {{
                    item.product.taxPerProduct
                      ? $numberFormat(item.product.taxPerProduct)
                      : $numberFormat(item.tax)
                  }}
                </span>
              </div>
            </div>
          </td>
          <td align="center" v-if="item && item.product">
            {{
              item.product.totalPerProduct
                ? $numberFormat(
                    Number(item.product.totalPerProduct) -
                      +item.product.discount +
                      +item.product.taxPerProduct
                  )
                : $numberFormat(item.fee * item.count - +item.discount + +item.tax)
            }}
          </td>
        </tr>
      </tbody>
      <tfoot v-show="status == 'print'">
        <tr>
          <td colspan="3">{{ $t("sum") }} {{ $t("discount") }}</td>
          <td colspan="3" align="center" style="font-weight: bold">
            {{ $numberFormat(discount) }} {{ $store.state.currency.name }}
          </td>
        </tr>
        <tr>
          <td colspan="3">{{ $t("sum") }} {{ $t("tax") }}</td>
          <td colspan="3" align="center" style="font-weight: bold">
            {{ $numberFormat(tax) }} {{ $store.state.currency.name }}
          </td>
        </tr>
        <tr v-if="credit != 0">
          <td colspan="3">
            {{ $t("club-credit") }}
          </td>
          <td colspan="3" align="center" style="font-weight: bold">
            {{ $numberFormat(credit) }} {{ $store.state.currency.name }}
          </td>
        </tr>
        <tr>
          <td colspan="6" align="center" style="font-weight: bold; font-size: 12px">
            {{ $t("payable") }} : {{ $numberFormat(payableAmount) }}
            {{ $store.state.currency.name }}
          </td>
        </tr>
        <tr v-if="content">
          <td colspan="6">{{ $t("content") }} : {{ content }}</td>
        </tr>
      </tfoot>
    </table>
    <div
      v-if="$store.state.allConfig && status == 'print'"
      style="font-size: 11px; margin-top: 5px; display: flex; justify-content: start"
    >
      {{ $store.state.allConfig.address }}
      {{ $store.state.allConfig.phone ? "-" + $store.state.allConfig.phone : "" }}
    </div>
    <div
      v-if="branchProp && branchProp.address"
      style="display: flex; justify-content: start; font-size: 11px"
    >
      {{ $t("branch-address") + ": " + branchProp.address }}
    </div>
    <div
      v-if="branchProp && branchProp.phone"
      style="display: flex; justify-content: start; font-size: 11px"
    >
      {{ $t("branch-phone") + ": " + branchProp.phone }}
    </div>
    <div
      v-if="userInfoProp && userInfoProp.init && userInfoProp.init.invoice_subtitle"
      style="display: flex; justify-content: start; font-size: 11px"
    >
      {{ userInfoProp.init.invoice_subtitle }}
    </div>
    <!--    <div-->
    <!--      v-show="id"-->
    <!--      style="margin-top: 15px"-->
    <!--      align="center"-->
    <!--    >-->
    <!--      <img-->
    <!--        width="80%"-->
    <!--        class="barcode"-->
    <!--        height="60px"-->
    <!--        :jsbarcode-value="number"-->
    <!--        jsbarcode-textmargin="0"-->
    <!--        jsbarcode-fontoptions="bold"-->
    <!--      >-->
    <!--    </div>-->
    <div align="center" style="font-size: 8px; padding-bottom: 20px">
      abriron.com - راهکار های مالی ابرآیرون
    </div>
  </div>
</template>

<script>
export function buildPrintHtmlFromBody(body) {
  return (
    '<!DOCTYPE html><html><meta charset="utf-8"><head>' +
    "<style scoped>" +
    "  thead > tr > td{border: 2px solid black;padding: 5px;font-size: 9px}" +
    "  tbody > tr > td{border: 2px solid black;padding: 5px;font-size: 9px}" +
    "  tfoot > tr > td{border: 2px solid black;padding: 5px;font-size: 9px}" +
    "@font-face {" +
    '  font-family: "IRANSans(FaNum)";' +
    '  src: url("https://abr.abriron.com/font/IRANSans(FaNum).ttf") format("truetype");' +
    "}" +
    '  body{font-family: "IRANSans(FaNum)";}' +
    "@page {" +
    "    padding: 0mm;" +
    "    margin: 0mm;" +
    " }" +
    " @media print {" +
    "    margin: 0mm; padding: 0mm" +
    "}" +
    "" +
    "</style>" +
    "" +
    "</head>" +
    '<body style="direction: rtl;">' +
    body +
    "</body>" +
    "</html>"
  );
}

export function getPrintFileName(invoiceNumber) {
  const stamp = new Date().toISOString().replace(/[:.]/g, "-").slice(0, 19);
  const numberPart =
    invoiceNumber != null && invoiceNumber !== "" ? `-${invoiceNumber}` : "";
  return `invoice-print${numberPart}-${stamp}.html`;
}

export function downloadPrintHtmlFile(html, fileName) {
  if (!html) {
    return;
  }
  const blob = new Blob([html], { type: "text/html;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName || "invoice-print.html";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export default {
  name: "IndexCategoryPrint",
  props: [
    "itemsProp",
    "accountProp",
    "dateProp",
    "sumProp",
    "totalDiscount",
    "contentProp",
    "totalTax",
    "idProp",
    "numberProp",
    "numberPrintProp",
    "statusProp",
    "branchProp",
    "creditProp",
    "userInfoProp",
  ],
  data() {
    return {
      date: null,
      time: null,
      account: null,
      items: null,
      content: null,
      credit: null,
      sum: 0,
      tax: 0,
      discount: 0,
      id: 0,
      number: 0,
      numberPrint: 0,
      status: "print",
    };
  },
  watch: {
    numberPrintProp(val) {
      this.numberPrint = val;
    },
    contentProp(val) {
      this.content = val;
    },
    dateProp(val) {
      this.date = val;
    },
    itemsProp(val) {
      this.items = val;
    },
    accountProp(val) {
      this.account = val;
    },
    creditProp(val) {
      this.credit = val;
    },
    sumProp(val) {
      this.sum = val;
    },
    totalDiscount(val) {
      this.discount = val;
    },
    totalTax(val) {
      this.tax = val;
    },
    statusProp(val) {
      this.status = val;
    },
    idProp(val) {
      this.id = val;
      // var app = this
      // setTimeout(function () {
      //   app.barcodeGenerate()
      // }, 10)
    },
    numberProp(val) {
      this.number = val;
    },
  },
  computed: {
    payableAmount() {
      const sumVal = Number(this.sum || 0);
      const creditVal = Number(this.credit || 0);
      return sumVal - creditVal;
    },
  },
  mounted() {
    this.date = this.dateProp;
    this.account = this.accountProp;
    this.items = this.itemsProp;
    this.sum = this.sumProp;
    this.discount = this.totalDiscount;
    this.tax = this.totalTax;
    this.id = this.idProp;
    this.number = this.numberProp;
    this.numberPrint = this.numberPrintProp;
    this.status = this.statusProp;
    this.content = this.contentProp;
    this.lockStatusItems = this.itemsProp;
    this.credit = this.creditProp;
    // var barcode = document.createElement('script')
    // barcode.setAttribute('src', 'https://abr.abriron.com/js/JsBarcode.all.min.js')
    // document.head.appendChild(barcode)
    // var app = this
    // setTimeout(function () {
    //   app.barcodeGenerate()
    // }, 5000)
    var today = new Date();
    this.time = today.getHours() + ":" + today.getMinutes();
  },
  methods: {
    barcodeGenerate() {
      window.JsBarcode(".barcode").init();
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "IRANSans";
}
thead > tr > td {
  border: 2px solid black;
  padding: 5px;
  font-size: 10px;
}
tbody > tr > td {
  border: 2px solid black;
  padding: 5px;
  font-size: 10px;
}
tfoot > tr > td {
  border: 2px solid black;
  padding: 5px;
  font-size: 10px;
}
</style>
